import React, { Component } from 'react';

import yaml from 'js-yaml';
import CodeMirrorComponent from './CodeMirror';

const unescape_ptr = val => val.replace('~0', '~').replace('~1', '/');

const add_location = (error, text) => {
  const {data_path} = error;
  const lines = text.split('\n');
  if (data_path) {
    const path = data_path.split('/').map(unescape_ptr).filter(part => part.length > 0);
    const indents = [];
    for (const [idx, line] of Object.entries(lines)) {
      const ltrimmed = line.trimLeft();
      const indent = line.length - ltrimmed.length;
      const last_indent = indents[indents.length - 1] || -1;
      while (indents.length > 0 && indent < last_indent) {
        indents.pop();
      }

      if (ltrimmed.startsWith(path[indents.length])) {
        if (indent > last_indent) {
          indents.push(indent);
        }
        if (indents.length === path.length) {
          error.from = {line: idx, ch: 0};
          error.to = {line: idx, ch: 1000};
          break;
        }
      }
    }
  }
  if (!error.from) {
    error.from = {line: 0, ch: 0};
  }
  if (!error.to) {
    error.to = {line: lines.length, ch: 0};
  }
  return error;
};

class DocView extends Component {
  async validate(data) {
    const doc = yaml.load(data);
    const errors = [];
    try {
      const res = await this.props.validator.validate(doc);
      if (!res) {
        errors.extend(this.props.validator.errors());
      }
    }
    catch(err) {
      errors.push({
        message: err,
        severity: 'error',
        data_path: null
      });
    }
    if (errors.length > 0) {
      this.props.onValidatedChange({raw: data});
      return {
        doc,
        errors: errors.map(err => {
          const {params = {}} = err;
          const {additionalProperty, missingProperty, format} = params;
          if (additionalProperty) {
            const actual_path = `${err.dataPath}/${additionalProperty}`;
            return add_location({
              message: `Schema Validation Error: Invalid property ${additionalProperty}\nData path: ${actual_path}`,
              severity: 'error',
              data_path: actual_path
            }, data);
          }
          else if (missingProperty) {
            return add_location({
              message: `Schema Validation Error: Missing required property ${missingProperty}\nData path: ${err.dataPath}`,
              severity: 'error',
              data_path: err.dataPath
            }, data);
          }
          else if (format) {
            return add_location({
              message: `Schema Validation Error: Invalid property format ${format}\nData path: ${err.dataPath}`,
              severity: 'error',
              data_path: err.dataPath
            }, data);
          }
          return add_location({
            message: `Schema Validation Error: ${err.message}\nData path: ${err.dataPath}\n`,
            severity: 'error',
            data_path: `${err.dataPath}/${_.get(err, 'params.additionalProperty', '')}`
          }, data);
        })
      };
    }
    this.props.onValidatedChange({doc, raw: data});
    return {
      doc,
      errors: []
    };
  }

  complete(path) {
    return this.props.validator.allowed_props(path);
  }

  render() {
    const {validate, complete} = this;
    const {theme, validator, readOnly, content, onDocChange, onPathChange, ...rest} = this.props;

    return <CodeMirrorComponent
      className='DocView'
      style={{height: '100%', ...this.props.style}}
      theme={theme}
      value={content}
      readOnly={readOnly}
      validate={validate.bind(this)}
      complete={complete.bind(this)}
      onDocChange={onDocChange}
      onPathChange={onPathChange}
      renderOnce={this.props.renderOnce}
      {...rest}
    />;
  }
}

const CodeMirror = CodeMirrorComponent.CodeMirror();

DocView.defaultProps = {
  readOnly: false,
  content: '',
  theme: 'bespin',
  renderOnce: false
};

export default DocView;
